"use client";

import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { num: '4,500', suffix: '+', label: '在售SKU', sublabel: 'Active SKUs' },
  { num: '500', suffix: '+', label: '合作夥伴', sublabel: 'Partners' },
  { num: '10', suffix: '年+', label: '行業經驗', sublabel: 'Years Experience' },
  { num: '24', suffix: 'h', label: '出貨響應', sublabel: 'Shipping Response' },
  { num: '98', suffix: '%', label: '客戶滿意度', sublabel: 'Satisfaction Rate' },
];

export default function StatsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 px-6 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #2C1A0E 0%, #8B5E3C 60%, #C4915A 100%)' }}
    >
      {/* Decorative pattern */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 50%, white 1px, transparent 1px), radial-gradient(circle at 75% 50%, white 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />
      <div className="max-w-container mx-auto relative z-10">
        <div className="text-center mb-12">
          <p className="text-white/60 text-xs tracking-widest uppercase mb-2">OUR NUMBERS · 我們的數據</p>
          <h2 className="font-heading font-bold text-white text-3xl md:text-4xl">
            數字背後，是信悅的承諾
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {stats?.map((stat, i) => (
            <div
              key={stat?.label}
              className="text-center p-6 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(30px)',
                transition: `opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${i * 100}ms, transform 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${i * 100}ms`,
              }}
            >
              <p className="font-heading font-black text-white leading-none mb-1" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
                {stat?.num}<span className="text-accent">{stat?.suffix}</span>
              </p>
              <p className="text-white font-semibold text-sm">{stat?.label}</p>
              <p className="text-white/50 text-xs mt-0.5">{stat?.sublabel}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}